import {useQuery} from '@tanstack/react-query'
import {useAccessToken} from '@salesforce/commerce-sdk-react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {useAppOrigin} from '@salesforce/retail-react-app/app/hooks/use-app-origin'
import {doCustomAPICall} from '../utils/custom-api-utils'

export const useApproachingPromo = (basketId) => {
    const {getTokenWhenReady} = useAccessToken()
    const config = getConfig()
    const appOrigin = useAppOrigin()
    const customAPIFolderName = 'approaching-shipping-promo'

    const apiPath = `get-approaching-shipping-promo?c_basketId=${basketId}`

    return useQuery({
        queryKey: ['custom', 'approaching-shipping-promo', basketId],
        queryFn: () =>
            doCustomAPICall(getTokenWhenReady, {
                config,
                appOrigin,
                customAPIFolderName,
                apiPath
            }),
        stale: 0,
        cache: 0
    })
}
